import { CompHiddenFieldCore } from '../core/forms/hidden-field/comp'

export const CompHiddenField = CompHiddenFieldCore
